<section class="main-content-wrapper">
  <div id="wrapper">
    <aside id="sidebar-wrapper">
      <div class="sidebar-nav">
        <nav id="side-bar" class="side-bar">
          <div class="side-bar-content">
            <div class="side-bar-menu">
              <ul>
                <li
                  *ngFor="let menu of MenuslinksNew"
                  [ngClass]="{
                    active: !menu.MM_IsShow,
                    'side-bar-dropdown': menu.MM_IsParent,
                    'header-menu': menu.MM_ParentID !== 0
                  }"
                >
                  <a
                    *ngIf="menu.MM_ParentID == 0"
                    [class.nav-bar-active]="
                      isLinkActive(!menu.MM_IsParent && [menu.MM_Url])
                    "
                    [routerLink]="menu.MM_IsParent ? null : [menu.MM_Url]"
                    [queryParams]="menu.MM_IsParent ? null : { fyear: FyearId, BranchId: BranchId }"
                    (click)="toggleNew(menu)"
                    style="cursor: pointer;"
                  >
                    <i
                      class="{{ menu.MM_iconName }}"
                      style="font-size: 0.6875rem"
                      aria-hidden="true"
                    ></i
                    ><span style="font-size: 0.6875rem">{{ menu.MM_Name }}</span>
                  </a>
                  <div
                    *ngIf="menu.MM_IsParent"
                    class="side-bar-submenu"
                    [@slide]="getStateNew(menu)"
                  >
                    <ul>
                      <li *ngFor="let submenu of MenuslinksNew">
                        <a
                          *ngIf="menu.MM_ID == submenu.MM_ParentID"
                          (click)="onMenuclick(submenu)"
                          [class.nav-bar-active]="
                            isLinkActive(
                              !submenu.MM_IsParent && [submenu.MM_Url]
                            )
                          "
                          [routerLink]="
                            submenu.MM_IsParent ? null : [submenu.MM_Url]
                          "
                          style="cursor: pointer;"
                        >
                          <span style="margin-left: 0.875rem; font-size: 0.6875rem">
                            <i
                              class="fa fa-arrow-right"
                              style="font-size: 0.6875rem"
                              aria-hidden="true"
                            ></i
                            >{{ submenu.MM_Name }}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    
    <div class="sidebar-copyright">
      © 2024 Designed and Powered By<br>
      <a href="http://finnaux.com" target="_blank">Finnaux Techsolutions Pvt. Ltd.</a><br>
      All Rights Reserved
    </div>
</aside>

    <div id="navbar-wrapper">
      <nav class="navbar navbar-inverse">
        <div class="container-fluid">
          <div class="navbar-header">
            <a href="#" class="navbar-brand" id="sidebar-toggle"><i class="fa fa-bars"></i></a>
          </div>
          <div class="font-size-15">
            <span class="navbar-text">{{ HeaderTitle }}</span>
          </div>
          <div class="navbar-actions"></div>
        </div>
      </nav>
    </div>

    <div class="main contents">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
